import React from 'react'
import actions from 'actions'
import 'react-select/dist/react-select.css'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { Alert, Row, Col } from 'antd'
import _get from 'lodash/get'
import Tooltip from 'components/modules/global/tooltip'
import ReactGA from 'helpers/react-ga'
import Button from 'components/modules/global/button'
import FormResponse from 'components/modules/global/form-response'
import { store } from '@src/app/index'
import SlugOffer from '@src/shared/slug-offer'
import { Holder } from '@src/components/elements'
// field components
import showError from 'components/modules/forms/showError'
import renderField from 'components/modules/forms/renderField'
import renderCheckbox from 'components/modules/forms/renderCheckbox'
import renderRichTextEditor from 'components/modules/forms/renderRichTextEditor'
// import renderRecaptcha from 'components/modules/forms/renderRecaptcha'
import renderSelect from 'components/modules/forms/renderSelect'
import inputFieldUrl from 'components/modules/forms/input-field/input-field-url'
// validation
import * as Api from '@src/api'
import validate from '../validation/sync-validation'
import asyncValidate from '../validation/async-validation'

let RegistrationFormComponent = props => {
	const {
		companyInfo,
		handleSubmit,
		options,
		registrationFormSuccess,
		registrationLoadCompanyNames,
		registrationLoadCompanyInfo,
		isLoading,
		change,
		// submitSucceeded,
	} = props
	const formValues = useSelector(state => _get(state, 'form.registration.values', {}))
	const history = useHistory()
	const intl = useIntl()
	const dispatch = useDispatch()
	const [isInvitationUsed, setIsInvitationUsed] = React.useState(false)
	const cit = history.getQuery && history.getQuery().cit
	const wasInvited = Boolean(cit)

	const companyInfoInit = React.useCallback(async () => {
		try {
			const company = await Api.Registration.getCompanyByInvitationToken(cit)

			dispatch(
				actions.registrationLoadCompanyInfoSuccess({
					data: { ...company, name: { cin: company.name, label: company.name } },
				})
			)
		} catch (err) {
			setIsInvitationUsed(true)
		}
	}, [])

	React.useEffect(() => {
		if (wasInvited) {
			companyInfoInit()
		}
	}, [])

	// field level validation function - recaptcha
	// const requiredRecaptcha = value => {
	// 	if (!value) {
	// 		return intl.formatMessage({
	// 			id: 'registration.registration.not_robot_confirm',
	// 			defaultMessage: 'Potvrďte, že nie ste robot',
	// 		})
	// 	}
	// }

	const hasCompanyFromFinstat = Object.keys(companyInfo).length > 0 && !companyInfo.id
	const isCompanyRegistered = Object.keys(companyInfo).length > 0 && companyInfo.id
	const wasNotInvitedOrInvitationWasUsed = !wasInvited || isInvitationUsed
	const wasInvitedAndIvnitationUsed = wasInvited && isInvitationUsed

	const nameToUrl = companyName => {
		const nameSlug = new SlugOffer({ text: companyName })
		const changeUrl = change('company_url', nameSlug.result)
		store.dispatch(changeUrl)
	}

	React.useEffect(() => {
		nameToUrl(formValues.name)
	}, [formValues.name])

	return (
		<form className="form" onSubmit={handleSubmit}>
			{registrationFormSuccess && (
				<FormResponse
					icon={{
						type: 'check-circle',
						color: 'success',
					}}
					text={intl.formatMessage({
						id: 'registration.registration_form.registration_success',
						defaultMessage:
							'Registrácia prebehla úspešne. Na vašu adresu bol odoslaný verifikačný email. Pre dokončenie registrácie kliknite na odkaz v emaili.',
					})}
					link={{
						route: '/admin',
						text: intl.formatMessage({
							id: 'registration.registration_form.company_account_managment',
							defaultMessage: 'Prejsť na správu firemného účtu',
						}),
					}}
				/>
			)}
			{!registrationFormSuccess && (
				<div>
					{wasInvitedAndIvnitationUsed && (
						<Alert
							message={intl.formatMessage({ id: 'general.warning' })}
							description={
								<FormattedMessage id="registration.registration_form.invitation_already_used" />
							}
							type="warning"
							showIcon={true}
							closable={true}
							className="m-b-l"
						/>
					)}
					{isCompanyRegistered && !wasInvited && (
						<Alert
							message={intl.formatMessage({ id: 'general.warning' })}
							description={
								<FormattedMessage
									id="registration.registration_form.company_already_registered"
									values={{
										companyName: companyInfo.name,
										strong: chunks => <strong>{chunks}</strong>,
									}}
								/>
							}
							type="warning"
							showIcon={true}
							className="m-b-l"
						/>
					)}
					<Field
						component={renderSelect}
						name="name"
						label={intl.formatMessage({
							id: 'registration.registration_form.name',
							defaultMessage: 'Názov zamestnávateľa *',
						})}
						disabled={!wasNotInvitedOrInvitationWasUsed && props.initialValues.name}
						options={options}
						onClick={registrationLoadCompanyInfo}
						onChange={option => nameToUrl(option && option.value)}
						onInputChange={registrationLoadCompanyNames}
						isLoading={isLoading}
						noResultsText={intl.formatMessage({
							id: 'registration.registration_form.no_results',
							defaultMessage: 'Žiadne výsledky',
						})}
						intl={intl}
					/>
					{wasNotInvitedOrInvitationWasUsed && !isCompanyRegistered && (
						<span>
							<Row gutter={[16, 16]}>
								<Col xs={{ span: 24 }} md={{ span: 12 }}>
									<Field
										component={renderField}
										name="formatted_address"
										label={intl.formatMessage({
											id: 'registration.registration_form.formatted_adress',
											defaultMessage: 'Adresa *',
										})}
										type="text"
										disabled={hasCompanyFromFinstat}
									/>
									<Field
										component={renderField}
										name="city"
										label={intl.formatMessage({
											id: 'registration.registration_form.city',
											defaultMessage: 'Mesto *',
										})}
										type="text"
										disabled={hasCompanyFromFinstat}
									/>
									<Row>
										<Col xs={{ span: 24 }} md={{ span: 12 }}>
											<Field
												component={renderField}
												name="postal_code"
												label={intl.formatMessage({
													id: 'registration.registration_form.postal_code',
													defaultMessage: 'PSČ *',
												})}
												type="text"
												disabled={hasCompanyFromFinstat}
											/>
										</Col>
									</Row>
								</Col>
								<Col xs={{ span: 24 }} md={{ span: 12 }}>
									<Field
										component={renderField}
										name="cin"
										label={intl.formatMessage({
											id: 'registration.registration_form.cin',
											defaultMessage: 'IČO',
										})}
										type="text"
										disabled={hasCompanyFromFinstat}
									/>
									<Field
										component={renderField}
										name="tin"
										label={intl.formatMessage({
											id: 'registration.registration_form.tin',
											defaultMessage: 'DIČ',
										})}
										type="text"
										disabled={hasCompanyFromFinstat}
									/>
									<Field
										component={renderField}
										name="tin_vat"
										label={intl.formatMessage({
											id: 'registration.registration_form.tin_vat',
											defaultMessage: 'IČ DPH',
										})}
										type="text"
										disabled={hasCompanyFromFinstat}
									/>

									{companyInfo.url && (
										<Row justify="end">
											<Col>
												<div className="finstat">
													<div className="finstat__text">
														<FormattedMessage
															id="registration.registration_form.data_security"
															defaultMessage="Aktuálne údaje zabezpečuje"
														/>
													</div>
													<div className="finstat__logo">
														<a
															target="_blank"
															rel="noreferrer"
															href={companyInfo.url}
															onClick={() => {
																ReactGA.event({
																	category: 'Ads',
																	action: 'Finstat click',
																	label: companyInfo.name,
																})
															}}
														>
															<img
																src="/media/images/logo-finstat.png"
																height="25"
																alt="FinStat"
															/>
														</a>
													</div>
												</div>
											</Col>
										</Row>
									)}
								</Col>
								<Col xs={{ span: 24 }}>
									<Field
										component={renderRichTextEditor}
										name="description"
										label={intl.formatMessage({
											id: 'registration.registration_form.description',
											defaultMessage: 'Popis spoločnosti *',
										})}
										disabled={isCompanyRegistered}
									/>
								</Col>
							</Row>

							<Row gutter={[16, 16]}>
								<Col xs={{ span: 24 }} md={{ span: 12 }}>
									<Field
										component={renderField}
										name="website"
										label={intl.formatMessage({
											id: 'registration.registration_form.website',
											defaultMessage: 'Webová stránka',
										})}
										type="text"
										disabled={isCompanyRegistered}
									/>
									<Field
										component={renderField}
										name="area"
										label={intl.formatMessage({
											id: 'registration.registration_form.area',
											defaultMessage: 'Oblasť pôsobenia *',
										})}
										type="text"
										disabled={isCompanyRegistered}
									/>
								</Col>
								<Col xs={{ span: 24 }} md={{ span: 12 }}>
									<Field
										component={renderField}
										name="employees"
										label={intl.formatMessage({
											id: 'registration.registration_form.employees',
											defaultMessage: 'Približný počet zamestnancov *',
										})}
										type="text"
										disabled={isCompanyRegistered}
									/>
								</Col>
								<Col xs={{ span: 24 }} md={{ span: 12 }}>
									<Field
										component={inputFieldUrl}
										name="company_url"
										label={intl.formatMessage({
											id: 'registration.registration_form.company_url',
										})}
										type="text"
										addonBefore={intl.formatMessage({
											id: 'registration.registration_form.company_url_host',
											defaultMessage: 'https://praxuj.sk/firma/',
										})}
										disabled={isCompanyRegistered}
									/>
								</Col>
							</Row>
						</span>
					)}
					<h2 className="form__title">
						<FormattedMessage
							id="registration.registration_form.personal_info"
							defaultMessage="Osobné údaje"
						/>
					</h2>
					<Row gutter={[16, 16]}>
						<Col xs={{ span: 24 }} md={{ span: 12 }}>
							<Field
								component={renderField}
								name="first_name"
								label={intl.formatMessage({
									id: 'registration.registration_form.first_name',
									defaultMessage: 'Meno *',
								})}
								type="text"
							/>
							<Field
								component={renderField}
								name="last_name"
								label={intl.formatMessage({
									id: 'registration.registration_form.last_name',
									defaultMessage: 'Priezvisko *',
								})}
								type="text"
							/>
							<Field
								component={renderField}
								name="telephone"
								label={intl.formatMessage({
									id: 'registration.registration_form.telephone',
									defaultMessage: 'Telefónne číslo *',
								})}
								type="tel"
							/>
						</Col>
						<Col xs={{ span: 24 }} md={{ span: 12 }}>
							<Field
								component={renderField}
								name="title_before"
								label={intl.formatMessage({
									id: 'registration.registration_form.title_before',
									defaultMessage: 'Titul (pred menom)',
								})}
								type="text"
							/>
							<Field
								component={renderField}
								name="title_after"
								label={intl.formatMessage({
									id: 'registration.registration_form.title_after',
									defaultMessage: 'Titul (za menom)',
								})}
								type="text"
							/>
						</Col>
					</Row>
					<h2 className="form__title">
						<FormattedMessage
							id="registration.registration_form.login_credentials"
							defaultMessage="Prihlasovacie údaje"
						/>
					</h2>
					<Field
						component={renderField}
						name="email"
						label={intl.formatMessage({
							id: 'registration.registration_form.email',
							defaultMessage: 'Email *',
						})}
						disabled={!wasNotInvitedOrInvitationWasUsed && props.initialValues.email}
						type="email"
						autocomplete="new-password"
					/>
					<div className="form__row">
						<Row gutter={[16, 0]}>
							<Col xs={{ span: 24 }} md={{ span: 12 }}>
								<Field
									component={renderField}
									name="password"
									label={intl.formatMessage({
										id: 'registration.registration_form.password',
										defaultMessage: 'Heslo *',
									})}
									type="password"
									autocomplete="new-password"
								/>
							</Col>
							<Col xs={{ span: 24 }} md={{ span: 12 }}>
								<Field
									component={renderField}
									name="passwordRepeat"
									label={intl.formatMessage({
										id: 'registration.registration_form.passwordRepeat',
										defaultMessage: 'Overenie hesla *',
									})}
									type="password"
									autocomplete="new-password"
								/>
							</Col>
						</Row>
					</div>
					<Tooltip
						content={intl.formatMessage(
							{
								id: 'registration.registration_form.data_processing',
								defaultMessage: `Užívateľ zaškrtnutím príslušnej kolonky udeľuje súhlas so spracuváním osobných údajov (meno, priezvisko, telefónne číslo, email, heslo) pre účely vytvorenia Účtu a poskytnutia možnosti prepojiť záujemcov a firmy v zmysle zákona č. 18/2018 Z.z., o ochrane osobných údajov, a Nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 z 27.4.2016.{breakingLine} Prevádzkovateľom v zmysle § 5 písm. o) zákona č. 18/2018 Z. z. je spoločnosť Praxuj s.r.o., Nový Svet 1182/40, Banská Bystrica 974 01, IČO 50 597 523, email: gdpr@praxuj.sk, zapísaná v Obchodnom registri Okresného súdu Banská Bystrica, oddiel Sro, vložka č. 30871/S. Prevádzkovateľ zriadil funkciu zodpovednej osoby, je ňou Jozef Gašparík, email: gdpr@praxuj.sk. Zodpovedná osoba je zároveň kontaktom pre všetky záležitosti týkajúce sa ochrany osobných údajov.{breakingLine} Účelom spracúvania je vytvorenie Účtu a poskytnutie možnosti prepojiť záujemcov a firmy.{breakingLine} Svoj súhlas so spracúvaním údajov môže Užívateľ kedykoľvek odvolať prostredníctvom emailu Prevádzkovateľa gdpr@praxuj.sk.{breakingLine} Súhlas je daný na dobu určitú na obdobie 3 rokov. Užívateľ môže tento súhlas opakovane predĺžiť potvrdením predlžovacieho emailu. Po uplynutí tejto doby budú údaje v anonymizovanej podobe uchovávané na štatistické účely.{breakingLine} Osobné údaje sú spracúvané automaticky. Pri spracúvaní Osobných údajov nedôjde k cezhraničnému prenosu do tretích krajín.{breakingLine} Užívateľ má právo na prístup k Osobným údajom, na opravu Osobných údajov, na vymazanie Osobných údajov, na obmedzenie spracúvania Osobných údajov, namietať spracúvanie Osobných údajov, na prenosnosť Osobných údajov, kedykoľvek svoj súhlas odvolať, podať návrh na začatie konania podľa § 100 zákona č. 18/2018 Z. z.{breakingLine} Užívateľ bude informovaný o porušení zabezpečenia osobných údajov.{breakingLine} Užívateľ môže na Prevádzkovateľa podať sťažnosť na Úrad pre ochranu osobných údajov Slovenskej republiky.`,
							},
							{
								breakingLine: <br />,
							}
						)}
					>
						<Field
							labelClassName="form__label--small"
							component={renderCheckbox}
							name="protection"
							label={intl.formatMessage({
								id: 'registration.registration_form.protection',
								defaultMessage: 'Súhlasím so spracúvaním osobných údajov *',
							})}
							type="checkbox"
						/>
					</Tooltip>
					<Tooltip
						content={intl.formatMessage(
							{
								id: 'registration.registration_form.email_processing',
								defaultMessage: `Užívateľ zaškrtnutím príslušnej kolonky udeľuje súhlas so spracúvaním svojho emailu pre účely zasielania newsletteru s reklamnými a marketingovými informáciami týkajúcich sa Služieb Prevádzkovateľa v zmysle zákona č. 18/2018 Z.z., o ochrane osobných údajov, a Nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 z 27.4.2016.{breakingLine} Prevádzkovateľom v zmysle § 5 písm. o) zákona č. 18/2018 Z. z. je spoločnosť Praxuj s.r.o., Nový Svet 1182/40, Banská Bystrica 974 01, IČO 50 597 523, email: gdpr@praxuj.sk, zapísaná v Obchodnom registri Okresného súdu Banská Bystrica, oddiel Sro, vložka č. 30871/S. Prevádzkovateľ zriadil funkciu zodpovednej osoby, je ňou Jozef Gašparík, email: gdpr@praxuj.sk. Zodpovedná osoba je zároveň kontaktom pre všetky záležitosti týkajúce sa ochrany osobných údajov.{breakingLine} Účelom spracúvania je poskytnutie reklamných a marketingových informácií týkajúcich sa Služieb Prevádzkovateľa Užívateľom{breakingLine} Svoj súhlas so spracúvaním údajov môže užívateľ kedykoľvek odvolať v odkaze v prijatom newsletteri alebo prostredníctvom emailu Prevádzkovateľa gdpr@praxuj.sk{breakingLine} Súhlas je daný na dobu určitú na obdobie 3 rokov. Užívateľ môže tento súhlas opakovane predĺžiť potvrdením predlžovacieho emailu. Po uplynutí tejto doby budú údaje v anonymizovanej podobe uchovávané na štatistické účely.{breakingLine} Osobné údaje sú spracúvané automaticky. Pri spracúvaní Osobných údajov nedôjde k cezhraničnému prenosu do tretích krajín.{breakingLine} Užívateľ má právo na prístup k Osobným údajom, na opravu Osobných údajov, na vymazanie Osobných údajov, na obmedzenie spracúvania Osobných údajov, namietať spracúvanie Osobných údajov, na prenosnosť Osobných údajov, kedykoľvek svoj súhlas odvolať, podať návrh na začatie konania podľa § 100 zákona č. 18/2018 Z. z.{breakingLine} Užívateľ bude informovaný o porušení zabezpečenia osobných údajov.{breakingLine} Užívateľ môže na Prevádzkovateľa podať sťažnosť na Úrad pre ochranu osobných údajov Slovenskej republiky.`,
							},
							{
								breakingLine: <br />,
							}
						)}
					>
						<Field
							labelClassName="form__label--small"
							component={renderCheckbox}
							name="newsletter"
							label={intl.formatMessage({
								id: 'registration.registration_form.newsletter',
								defaultMessage: 'Súhlasím s odberom noviniek a zasielaním zaujímavých ponúk na email',
							})}
							type="checkbox"
						/>
					</Tooltip>
					{/* {process.env.ENVIRONMENT === 'production' && (
						<Field component={renderRecaptcha} name="recaptcha" validate={requiredRecaptcha} />
					)} */}
					<div className="form__submit" data-cy="form-submit">
						<Button
							type="submit"
							color="brand"
							text={intl.formatMessage({
								id: 'registration.registration_form.register',
								defaultMessage: 'Registrovať sa',
							})}
							disabled={props.submitting}
						/>
					</div>
					<div className="bottom-line">
						<FormattedMessage
							id="registration.registration_form.email_processing"
							defaultMessage="* Polia označené hviezdičkou sú povinné"
						/>
					</div>
				</div>
			)}
		</form>
	)
}

RegistrationFormComponent = reduxForm({
	form: 'registration',
	destroyOnUnmount: true,
	enableReinitialize: true,
	validate,
	asyncValidate,
	onSubmitFail: showError,
	onSubmitSuccess: (result, dispatch) => dispatch(actions.registrationFormSetSuccess()),
	asyncBlurFields: ['name', 'email'],
})(RegistrationFormComponent)

RegistrationFormComponent = connect(state => ({
	initialValues: state.registration.companyInfo,
	companyInfo: state.registration.companyInfo,
}))(RegistrationFormComponent)

// exporting const because of no-mutable-exports
const RegistrationForm = RegistrationFormComponent

export default RegistrationForm
